import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedRoutingModule } from './feed-routing.module';
import { FeedComponent } from './feed.component';
import { ResourcesComponent } from '../resources/resources.component';
import { FeatureComponent } from '../wordpress-resources/feature/feature.component';
import { FeedFullListComponent } from './feed-full-list/feed-full-list.component';
import { FeedFeatureComponent } from './feed-feature/feed-feature.component';

@NgModule({
  imports: [
    CommonModule,
    FeedRoutingModule,
    ResourcesComponent,
    FeatureComponent
  ],
  declarations: [
    FeedComponent,
    FeedFullListComponent,
    FeedFeatureComponent
  ]
})
export class FeedModule { 
}  